import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'; // this is needed!
import {RouterModule, UrlSerializer} from '@angular/router';
import {HttpModule} from '@angular/http';
import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {FormsModule} from '@angular/forms';
/* COMPONENTES DE LAYOUT */
import {LayoutModule} from './layout/layout.module';
/* MODULO DE AUTENTICACION */
import {AutenticacionModule} from './autenticacion/autenticacion.module';
import {AuthService} from './autenticacion/servicios/auth.service';
import {AuthGuard} from './autenticacion/servicios/auth-guard.service';

import {UtilConfig} from './autenticacion/servicios/UtilConfig';

import {AppComponent} from './app.component';

import {FixedpluginModule} from './layout/shared/fixedplugin/fixedplugin.module';

import {MODULE_ROUTES} from './app.routing';
import {DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule} from "@angular/material";
import {CustomUrlSerializer} from "./layout/recursos/modelo/UrlSerializer/custom-url-serializer";
import {MOMENT_DATE_FORMATS, MomentDateAdapter} from "./layout/recursos/modelo/moment-date-formats";

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule.forRoot(MODULE_ROUTES),
        HttpModule,
        LayoutModule,
        AutenticacionModule,
        MatNativeDateModule,
        FixedpluginModule
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        AuthService,
        AuthGuard,
        UtilConfig,
        {provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS},
        {provide: DateAdapter, useClass: MomentDateAdapter},
        {provide: UrlSerializer, useClass: CustomUrlSerializer}
    ],
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/app.module.ts